import React from 'react'

import { CONFIGS } from '../../utils'

export const formDefaultFields: IFormFieldsSection[] = [
  {
    name: 'basic-info',
    groupLabel: 'Create your account.',
    groupLabelClassName: '',
    groupClassName: '',
    fields: [
      {
        className: 'half-width',
        name: 'firstName',
        label: 'First Name',
        type: 'text',
        required: true,
        onValidate: null,
      },
      {
        className: 'half-width',
        name: 'lastName',
        label: 'Last Name',
        type: 'text',
        required: true,
        onValidate: null,
      },
      {
        name: 'email',
        label: 'Email',
        type: 'email',
        required: true,
        onValidate: null,
      },
      {
        name: 'confirmEmail',
        label: 'Confirm Email',
        type: 'email',
        required: true,
        onValidate: null,
      },
    ],
  },
  {
    name: 'billing-info',
    groupLabel: '',
    groupLabelClassName: '',
    groupClassName: '',
    fields: [
      {
        className: 'half-width',
        name: 'zip',
        label: 'Post Code/Zip',
        type: 'text',
        required: true,
        onValidate: null,
      },
      {
        className: 'half-width',
        name: 'country',
        label: 'Country',
        type: 'select',
        required: true,
        onValidate: null,
      },
    ],
  },
  {
    name: 'password-info',
    groupLabel: (
      <div className="email-info-block">
        <span>Choose a password for your new</span>
        <b> {CONFIGS.CLIENT_NAME || 'Mana Common'} </b>
        <span>account</span>
      </div>
    ),
    groupLabelClassName: '',
    groupClassName: '',
    fields: [
      {
        className: 'half-width',
        name: 'password',
        label: 'Password',
        type: 'password',
        required: true,
        onValidate: null,
      },
      {
        className: 'half-width',
        name: 'confirmPassword',
        label: 'Confirm Password',
        type: 'password',
        required: true,
        onValidate: null,
      },
    ],
  },
]
